import React, { useMemo, useEffect } from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { useThemeMode } from "hooks/useThemeMode";
import { darkPalette } from "helpers/themeColors";

export function ThemeWrapper({ children }) {
  const { themeMode, isDark } = useThemeMode();

  const theme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: themeMode,
          ...(isDark
            ? {
                background: {
                  default: darkPalette.bgDefault,
                  paper: darkPalette.cardBg,
                },
                text: {
                  primary: darkPalette.textPrimary,
                  secondary: darkPalette.textSecondary,
                },
              }
            : {}),
        },
        components: {
          MuiTextField: {
            styleOverrides: {
              root: {
                "& input[type=number]": { textAlign: "end" },
                '& input[right="1"]': { textAlign: "end" },
              },
            },
          },
          MuiDrawer: {
            styleOverrides: {
              paper: ({ theme }) => ({
                [theme.breakpoints.up("md")]: { width: 260 },
              }),
            },
          },
          ...(isDark
            ? {
                MuiPaper: {
                  styleOverrides: {
                    // Disable MUI v5 elevation overlay that lightens dark surfaces
                    root: {
                      backgroundImage: "none",
                    },
                  },
                },
                MuiAutocomplete: {
                  styleOverrides: {
                    paper: {
                      backgroundColor: darkPalette.cardBg,
                      color: darkPalette.textPrimary,
                    },
                    option: {
                      '&[aria-selected="true"]': {
                        backgroundColor: `${darkPalette.selectedBg} !important`,
                        color: darkPalette.accent,
                      },
                      '&.Mui-focused, &:hover': {
                        backgroundColor: `${darkPalette.hoverBg} !important`,
                      },
                    },
                  },
                },
              }
            : {}),
        },
      }),
    [themeMode, isDark],
  );

  useEffect(() => {
    document.body.setAttribute("data-theme", themeMode);
    // Also set on html for broader CSS variable access
    document.documentElement.setAttribute("data-theme", themeMode);
  }, [themeMode]);

  return (
    <ThemeProvider theme={theme}>
      {children}
    </ThemeProvider>
  );
}
